// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"Settings_inputContainer__3pqHV","table":"Settings_table__3uJ7J"};